/**
 * GuideViewToggle — Short/Full guide segmented control
 */

import type { DebriefingGuideView } from '../../lib/short-debriefing-guide.types';

interface GuideViewToggleProps {
  view: DebriefingGuideView;
  onChange: (view: DebriefingGuideView) => void;
}

export default function GuideViewToggle({ view, onChange }: GuideViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-steel/20 bg-white p-0.5 shadow-sm">
      <button
        onClick={() => onChange('short')}
        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
          view === 'short'
            ? 'bg-navy text-white'
            : 'text-steel hover:text-navy'
        }`}
      >
        Short Guide
      </button>
      <button
        onClick={() => onChange('full')}
        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
          view === 'full'
            ? 'bg-navy text-white'
            : 'text-steel hover:text-navy'
        }`}
      >
        Full Guide
      </button>
    </div>
  );
}
